import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../../context/store";
import { functions } from "../../../constants/common-functions";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STRINGIFY } from "../../../constants/general-constants";
import background from "../../../../images/background.jpg";
import FolderForagerTreePanel from "../../documents/components/FolderForagerTreePanel";
import FolderForagerHeader from "../../documents/components/FolderForagerHeader";
import FolderForagerDocumentsPanel from "../../documents/components/FolderForagerDocumentsPanel";
import FolderForagerDocumentPopup from "../../documents/components/FolderForagerDocumentPopup";
import useFolderForagerBuilding
from "../hooks/useFolderForagerBuilding";
import { faAngleLeft }
from "@fortawesome/free-solid-svg-icons";


import {
  OMNISCAN_BLUE
} from "../../../constants/colors";

export default function FacilityForagerDocuments(
{
    buildingId,
    buildingName,
	buildingCode,
    displayFlag,
    closeFunction
}){

  const globalState = useContext(store);
  const history = useHistory();
  
  const id = null;
  
  const
  {
      loading,

      directories,

      selectedDirectory,

      documents,

      selectedDocument,
	  
	  setSelectedDocument,

      expandDirectory,

      selectDirectory,

      selectDocument

  }
  =
  useFolderForagerBuilding(buildingId, buildingCode);
 
 
  
  
  const [searchText,
         setSearchText] =
      useState("");
	  
	  
	  const [openDocumentUrl, setOpenDocumentUrl] =
	      useState(null);

	  const [openDocument, setOpenDocument] =
	      useState(null);
		  
     const [documentBlob, setDocumentBlob] = useState({})
 

  // ---------------- STYLES ----------------

  const filteredDocuments =
       documents.filter(doc =>
           doc.title
               .toLowerCase()
               .includes(searchText.toLowerCase())
   );

  const arrowHolder =
  {
      display: "flex",

      width: "42px",
      height: "42px",

      background:
          "linear-gradient(180deg,#ffffff 0%,#e7e9ec 100%)",

      alignItems: "center",
      justifyContent: "center",

      borderRadius: "21px",

      boxShadow:
          "0 6px 16px rgba(0,0,0,0.18)",

      cursor: "pointer",

      zIndex: 10000000
  };

  const drawerContainer =
  {
      display: "flex",
	  position: "fixed",

	     top: "0px",
	     left: "-60px",

	    
      width: "calc(100% + 60px)",

      alignItems: "center",
	  zIndex:10000000
  };

  const drawer =
  {
      position: "relative",

      display: "flex",

      flexDirection: "column",

      width: "calc(100vw + 40px)",

      height: "calc(100vh - 0px)",

      overflow: "hidden",

      backgroundImage: `url(${background})`,

      backgroundSize: "cover",

      backgroundPosition: "center",

      boxShadow:
          "0 22px 60px rgba(0,0,0,.30)",
		  
  };
  
  const overlay =
  {
      position: "absolute",

      top: 0,
      left: 0,
      right: 0,
      bottom: 0,

      background:
          "linear-gradient(rgba(255,255,255,.55),rgba(255,255,255,.45))",

      backdropFilter: "blur(2px)",

      pointerEvents: "none",

      zIndex: 0
  };
  
 

 const openFile = (doc) => {
	
	functions.getBlobFromAjax(
	 	        "/resolutionsoftwareplatform/api/sharepoint/file/" + doc.sharePointId,
	 	        function(blob)
	 	        {
					setDocumentBlob(blob);
	 	            const url =
	 	                window.URL.createObjectURL(blob);
					
	 	            setSelectedDocument(doc);
	 	            setOpenDocumentUrl(url);
	 	        }
	 	    );
 }
 


  // ---------------- RENDER ----------------
  
  return (


	<div
	    style={{
	        ...drawerContainer,
	        transform: displayFlag
	            ? "translateX(0)"
	            : "translateX(-105%)",

	        opacity: displayFlag ? 1 : 0,

	        transition:
	            "transform .45s cubic-bezier(.22,.61,.36,1), opacity .35s",

	        pointerEvents: displayFlag ? "auto" : "none"
	    }}
	>

         

          <div style={drawer}>

		  <div style={overlay}/>

		  	<FolderForagerTreePanel

		  	    directories={directories}

		  	    selectedDirectory={selectedDirectory}

		  	    onExpand={expandDirectory}

		  	    onSelect={selectDirectory}

		  	/>

		  	<FolderForagerHeader

		  	      directory={selectedDirectory}

		  	      documentCount={documents?.length}

		  	      searchText={searchText}

		  	      onSearchChange={setSearchText}

		  	  />  
		  	  
		  	  
		  	  <FolderForagerDocumentsPanel
		  	      documents={filteredDocuments}
		  	      selectedDocument={selectedDocument}
		  	      openFile={openFile}
		  		
		  	  />
		  	  {
		  	        openDocumentUrl
		  	        &&
		  			<>
		  	        <div
		  	            style={{

		  	                position: "fixed",

		  	                top: "0px",
		  	                left: "50px",
		  	                right: "0px",
		  	                bottom: "0px",

		  	                background: "rgba(255,255,255,.95)",


		  	                overflow: "hidden",

		  	                zIndex: 400,

		  	                boxShadow:
		  	                    "0 18px 45px rgba(0,0,0,.25)"

		  	            }}
		  	        >
		  	            <iframe
		  	                src={openDocumentUrl}
		  	                title={
		  	                    openDocument
		  	                    ?
		  	                    openDocument.title
		  	                    :
		  	                    "Document"
		  	                }
		  	                style={{
		  	                    width: "100%",
		  	                    height: "100%",
		  	                    border: "none"
		  	                }}
		  	            />
		  	        </div>
		  			<FolderForagerDocumentPopup
		  			document={selectedDocument}
		  			onClose={() =>
		  			   {
		  			       setOpenDocumentUrl(null);
		  			       setOpenDocument(null);
		  			       setSelectedDocument(null);
		  			   }}
		  			/>
		  			</>
		  	    }
		       </div>
			   <div
			                style={arrowHolder}

			                onClick={closeFunction}
			            >
			                <FontAwesomeIcon icon={faAngleLeft}/>
			            </div>
		    </div>

 

  );
}

